/* eslint-disable no-prototype-builtins,@typescript-eslint/no-unused-vars */

xplenty.controller('ComponentFormStep', [
  '$scope',
  'componentFormTagsService',
  '$translate',
  '$timeout',

  function ($scope, componentFormTagsService, $translate, $timeout) {
    let stepName = 'componentFormStep';

    if (!$scope[stepName]) {
      $scope[stepName] = $scope.$parent.createStep(
        $translate.instant(`component-editor.step-editor.${$scope.component.componentType}.closed`),
        $translate.instant(`component-editor.step-editor.${$scope.component.componentType}.active`),
        $scope.component.editorDirective,
      );
    } else {
      stepName = 'secondFormStep';
      $scope[stepName] = $scope.$parent.createStep(
        $translate.instant(`component-editor.step-editor.${$scope.component.componentType}.closed`),
        $translate.instant(`component-editor.second-step-editor.${$scope.component.componentType}.active`),
        $scope.component.secondEditorDirective,
      );
    }

    $scope.$on('formLocator', function (event) {
      $scope.componentForm = event.targetScope.componentForm;
    });

    $scope[stepName].validate = function (isError = false) {
      const form = $scope.componentForm || ($scope.form && $scope.form.componentForm);
      this.valid = form && form.$valid && !isError;
      this.error = (function () {
        let error = false;
        if (form) {
          _.each(form, function (value, key) {
            if (typeof value === 'object' && value.hasOwnProperty('$modelValue')) {
              if (value.$invalid && value.$dirty) {
                error = true;
              }
            }
          });
          if (!error && form.$error.fieldsCollection) error = true;
        }
        return error;
      })();

      $timeout(function () {
        $scope[stepName].tags = componentFormTagsService.getTags($scope.component);
      });
      return this.valid;
    };

    let lastComponentData = null;
    $scope[stepName].isChanged = function () {
      let isChanged = true;
      if (lastComponentData === null) {
        lastComponentData = angular.copy($scope.component);
        delete lastComponentData.schema;
      } else {
        const currentComponentData = angular.copy($scope.component);
        delete currentComponentData.schema;
        if (_.isEqual(lastComponentData, currentComponentData)) {
          isChanged = false;
        } else {
          lastComponentData = currentComponentData;
        }
      }
      return isChanged;
    };
  },
]);
